<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
	
export default {
  name: 'App'
}
</script>

<style>
  body{
    width:100%;
    margin:0 auto;
    height: 1080px;
    overflow: hidden;
    background: #000;
  }
  @font-face {
    font-family: "本墨字语";
    src: url("./assets/本墨字语.ttf");
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;

}
::-webkit-scrollbar {
  width: 8px;

  height: 16px;

  background-color: transparent;
}

/*定义滚动条轨道
	
	内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

  border-radius: 10px;

  background-color: rgba(2, 28, 51, .7);
}

/*定义滑块
	
	内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 10px;

  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

   
  background-image: linear-gradient(#133ea2, #8707dd);
}
</style>




// WEBPACK FOOTER //
// src/App.vue